import { render } from "./Build.vue?vue&type=template&id=eed8c5f2"
import script from "./Build.vue?vue&type=script&lang=ts"
export * from "./Build.vue?vue&type=script&lang=ts"
script.render = render

export default script